import * as TYPES from './language-actiontypes';
import { getStateFromLocal } from '../../webstorage';

export const LOCAL_STORAGE_KEY = 'patient:language';

const initialState = {
  languageCode: null,
  languageTranslations: null,
  translations: null,
};

export const hasLocalLanguageState = () => getStateFromLocal(LOCAL_STORAGE_KEY, null) !== null;

const languageReducer = (state = getStateFromLocal(LOCAL_STORAGE_KEY, initialState), action) => {
  let newState;
  switch (action.type) {
    case TYPES.LANGUAGE_CHANGE:
      newState = { ...action.state };
      break;
    case TYPES.TRANSLATIONS_LOADED_SUCCESS:
    case TYPES.TRANSLATIONS_LOAD_FAILED:
      newState = { ...state, translations: action.translations };
      break;
    case TYPES.LANGUAGE_TRANSLATIONS_LOAD_SUCCEEDED:
      newState = { ...state, languageTranslations: action.languageTranslations };
      break;
    default:
      newState = state;
  }
  return newState;
};

export default languageReducer;
